import { NgModule } from '@angular/core';

import { BackgroundComponent } from './background.component';

@NgModule({
  imports: [],
  exports: [BackgroundComponent],
  declarations: [BackgroundComponent],
  providers: [],
})
export class BackgroundModule { }
